import type React from 'react';
import { memo } from 'react';
import { SCity, SMenuDropdown } from '@widgets/coaches/filter/citiesSearch/styles';
import { useGetCitiesQuery } from '@shared/api/deliveryService';
import { Location as LocationIcon } from '@shared/assets';
import { MenuItem, useCommonMenu } from '@shared/ui';
import { SearchInput } from '@shared/ui/inputs/searchInput/index.ts';
import { useDebounce } from '@src/library/hooks/common/hooks';

type Props = {
  search: string;
  setSearch: (v: string) => void;
  onSelect: (id: number) => void;
};

export const CitiesSearch: React.FC<Props> = memo(({ search, setSearch, onSelect }) => {
  const { onOpen, onClose, setReferenceEl, referenceEl, popperEl, setPopperEl } = useCommonMenu();

  const debouncedSearch = useDebounce(search, 1000);

  const { data: citiesData } = useGetCitiesQuery(
    { search: debouncedSearch },
    {
      skip: debouncedSearch === '',
    }
  );

  return (
    <div id={`button-forCities`} onClick={onOpen} ref={(ref) => setReferenceEl(ref)}>
      <SearchInput
        isOpenInit={true}
        isClosable={false}
        value={search}
        onChange={(e) => setSearch(e.currentTarget.value)}
        leftIcon={<LocationIcon />}
      >
        <SMenuDropdown
          $haveItems={!!citiesData?.results?.length}
          id={'forCities'}
          referenceEl={referenceEl}
          popperEl={popperEl}
          setPopperEl={setPopperEl}
          // Кринжевый кошмар, но иначе не справится........
          style={{}}
        >
          {citiesData?.results?.map((c) => {
            // Если город, который вводили, имеется в списке, то он выберется ^^)
            // c.title === search && onSelect(c.id);

            return (
              <MenuItem
                key={c.city_uuid}
                onClick={(e) => {
                  onClose(e);
                  setSearch(c.full_name);
                  onSelect(c.city_uuid);
                }}
              >
                <SCity>{c.full_name}</SCity>
              </MenuItem>
            );
          })}
        </SMenuDropdown>
      </SearchInput>
    </div>
  );
});
